export const Endpoint = {
  LOGIN: "/v1/user/login",
  CREATE_NONCE: "/v1/user/create-nonce",
  REGISTER: "/v1/user/register",
  SEND_OTP: "/v1/user/send-otp",
  LIST_ON_SALE: "/market-place/list-item",
  DETAIL_ON_MARKET: "market-place/item",
  DETAIL_ON_INVENTORY: "item/",
  DETAIL_ON_EVEMT: "/item/event/",
  LIKE_NFT: "market-place/like",
  DISLIKE_NFT: "market-place/dislike",
  USER_COLLECTION: "item/user-collection",
  LIST_COLLECTION: "item/list-collection",
  USER_TOP_SELLER: "/v1/user/top-seller",
  USER_TOP_CREATER: "/v1/user/top-creator",
  USER_TOP_COLLECTION: "/v1/user/top-collection",
  LIKE_COLLECTION: "item/collection/like",
  DISLIKE_COLLECTION: "item/collection/dislike",
  NOTIFICATION_LIST: "/notifications/search",
  READ_NOTIFICATION_LIST: "/notification/change-status",
  READ_ALL_NOTIFICATION_LIST: "notification/read-all",
  GET_NOTIFICATION_SETTING_LIST: "notification/setting",
  POST_NOTIFICATION_SETTING_LIST: "notification/update-setting",
  HOT_BRANDS: "market-place/list-brand",
  HOT_BRANDS_NEW: "market-place/list-brand-image",
  HOT_AUCTIONS: "market-place/list-item",
  BANNERS: "market-place/setting/default",
  CATEGORY_LIST: "categories/search",
  NFT: "nfts",
  
  // Lucky Draw API Endpoints
  LUCKY_DRAW_CURRENT: "/lucky-draw/current",
  LUCKY_DRAW_LAST_ROUND: "/lucky-draw/last-round",
  LUCKY_DRAW_NEXT_DRAW: "/lucky-draw/next-draw",
  LUCKY_DRAW_RULES: "/lucky-draw/rules",
  LUCKY_DRAW_TOP_WINNERS: "/lucky-draw/top-winners",
  LUCKY_DRAW_TICKET_SOLD_DETAILS: "/lucky-draw/ticket-sold-details",
  LUCKY_DRAW_BUY: "/lucky-draw/buy",
  LUCKY_DRAW_ROUNDS_SEARCH: "/lucky-draw/rounds/search",
  LUCKY_DRAW_ROUNDS_SUMMARY: "/lucky-draw/rounds-summary",
  LUCKY_DRAW_MY_TICKETS: "/lucky-draw/my-tickets",
  LUCKY_DRAW_MY_ROUNDS: "/lucky-draw/my-rounds",
  LUCKY_DRAW_REFERRAL_STATS: "/lucky-draw/referral-stats",
  LUCKY_DRAW_REFERRAL_LINK: "/lucky-draw/referral-link",
  LUCKY_DRAW_CLAIM: "/lucky-draw/claim-award-prize",
  LUCKY_DRAW_MY_REFERRAL: "/lucky-draw/my-referrals",
}
